<template>
    <div
        v-if="report"
        ref="report"
        style="
            width: 100%;
            height: calc(100vh - 64px - 52px);
            min-height: 400px;
            overflow-y: auto;
            overflow-x: auto;
            font-size: 8pt;
            padding: 24px;
        "
        class="scrollbar-hidden"
    >
        <svg
            v-for="reportElement of report.elements"
            :key="reportElement.id"
            :id="reportElement.id"
            ref="svg"
            class="designer-container designer-layout report-element"
            width="100%"
            height="100%"
            :viewBox="`0 0 ${report.elementWidth} ${report.elementHeight}`"
            preserveAspectRatio="xMidYMid meet"
        >
            <defs>
                <filter id="shadow">
                    <feDropShadow dx="0" dy="0" stdDeviation="0.5" />
                </filter>
            </defs>
            <g v-if="isDashboardReport" id="dashboard-report">
                <!-- :fill="'#9fe5888f'"  -->
                <rect
                    :fill="'#ffffff'"
                    style="filter: url(&quot;#shadow&quot;)"
                    :x="dashboardReportElement.x"
                    :y="dashboardReportElement.y"
                    :width="dashboardReportElement.width"
                    :height="dashboardReportElement.height"
                    :stroke="'grey'"
                    stoke-width="1"
                />
            </g>
            <!-- <rect x="0" y="0" width="100%" height="100%" :fill="'rgba(207, 207, 207, 255)'" :stroke="'whitesmoke'" stoke-width="0.5"></rect> -->
            <!-- <g>
                <rect v-for="cell of layout.gridCells" :key="cell.id"
                    :x="cell.x" :y="cell.y" :width="cell.width" :height="cell.height"
                    stroke="whitesmoke" stoke-width="0.5" fill="transparent" style="border-collapse: collapse;" :visibility="preview ? 'hidden' : 'visible'"></rect>
            </g> -->
            <!-- <g> -->
            <!-- <template v-for="box of layout.children">
                    <BoxComponent
                        :key="box.id"
                        :box="box"
                        :selected="isBoxSelected(box)"
                        :selectedBoxObj="selectedBox"
                        @selected-box="handleSelectedBox($event)"
                        @moved-box="() => {}"
                        :preview="preview"
                        ref="boxComponent"
                    >
                    </BoxComponent>
                </template> -->
            <!-- </g> -->

            <g>
                <BoxComponent
                    v-for="box of reportElement.children"
                    :key="box.id"
                    :box="box"
                    viewType="REPORT"
                    :selectedBoxObj="selectedBox"
                    :hideMenuOptions="hiddenObjectsMenuOptions"
                    @selected-box="handleSelectedBox($event)"
                    ref="reportBoxComponent"
                />
                <!-- <BoxComponent v-for="box of container.children"
                    :key="box.id"
                    :box="box"
                    selected="isBoxSelected(box)"
                    selected-box="handleSelectedBox($event)"
                    moved-box="() => {}"
                    :preview="preview"
                    ref="boxComponent"
                >
                </BoxComponent> -->
            </g>
        </svg>
    </div>
</template>
<script lang="ts">
import BoxComponent from "./BoxComponent.vue";
import {
    Box,
    GridContainer,
    Layout,
    LayoutMode,
    Report,
    ReportElement,
    ReportType,
} from "./models";
import { Prop } from "vue-facing-decorator";
import { Component, Vue, toNative } from "vue-facing-decorator";

interface MoveCoordinates {
    screenX?: number;
    screenY?: number;
}

// TODO: continue implementation for dashboard report type and make it general. A dashboard could be applicable to a slide.
// TODO: CHECKPOINT: Handle dashboard type, slide type and pdf document type.
@Component({
    components: {
        BoxComponent,
    },
    emits: ["report", "selected-box"],
})
export class ReportPage extends Vue {
    @Prop({ default: null, required: true }) readonly themeSettings!: any;
    @Prop({ default: ReportType.DASHBOARD }) readonly reportType: ReportType;
    @Prop({ default: null }) readonly initialReport: Report;

    selectedBox: Box = null;

    report: Report = null;

    hiddenObjectsMenuOptions = ["visible", "clone"];

    beforeMount() {
        this.initListeners();
        if (this.initialReport) {
            this.report = this.initialReport;
        } else {
            this.report = new Report(
                this.reportType,
                "Rapport test",
                "Rapport test",
                this.themeSettings,
            );
            this.emitReport(this.report);
            const reportElement = new ReportElement();
            this.report.addElement(reportElement);
            console.log("report", this.report);
        }
    }

    beforeDestroy() {
        this.removeListeners();
    }

    emitReport(report: Report): void {
        this.$emit("report", report);
    }

    /**
     * If the report exists and is of type ReportType.DASHBOARD
     */
    get isDashboardReport() {
        return this.report?.type === ReportType.DASHBOARD;
    }

    get dashboardReportElement(): ReportElement {
        if (this.isDashboardReport) {
            return this.report.elements[0];
        }
        return null;
    }

    handleSelectedBox(box) {
        if (this.selectedBox) {
            // Unselect previous box
            this.selectedBox.isSelected = false;
        }
        this.selectedBox = box;
        if (this.selectedBox) {
            // Selected box can be null
            this.selectedBox.isSelected = true;
        }
        this.$emit("selected-box", box);
        console.log("handling selected-box", box);
    }

    initListeners() {
        document.addEventListener("click", this.onClick);
    }

    removeListeners() {
        document.removeEventListener("click", this.onClick);
    }

    onClick(evt) {
        if (!evt.target?.closest(".box-group") && evt.target?.closest(".report-element")) {
            this.handleSelectedBox(null);
        }
    }
}

export default toNative(ReportPage);
</script>
<style scoped></style>
